var _toConsumableArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.metaTags = void 0;

var metaTags = function metaTags(metadata) {
  var _a, _b, _c, _d, _e, _f;

  return [{
    name: "description",
    content: metadata.description
  }, {
    name: "image",
    content: (_a = metadata === null || metadata === void 0 ? void 0 : metadata.image) === null || _a === void 0 ? void 0 : _a.url
  }, {
    property: "og:title",
    content: metadata === null || metadata === void 0 ? void 0 : metadata.title
  }, {
    property: "og:description",
    content: metadata.description
  }, {
    property: "og:type",
    content: metadata === null || metadata === void 0 ? void 0 : metadata.type
  }, {
    property: "og:image",
    content: (_b = metadata === null || metadata === void 0 ? void 0 : metadata.image) === null || _b === void 0 ? void 0 : _b.url
  }, {
    property: "og:image:alt",
    content: (_c = metadata === null || metadata === void 0 ? void 0 : metadata.image) === null || _c === void 0 ? void 0 : _c.description
  }, {
    property: "og:locale",
    content: metadata.lang
  }, {
    property: "og:site_name",
    content: metadata === null || metadata === void 0 ? void 0 : metadata.siteName
  }, {
    property: "og:url",
    content: metadata === null || metadata === void 0 ? void 0 : metadata.pageUrl
  }, {
    property: "fb:app_id",
    content: metadata === null || metadata === void 0 ? void 0 : metadata.facebookAppID
  }, {
    name: "twitter:card",
    content: "summary_large_image"
  }, {
    name: "twitter:creator",
    content: metadata === null || metadata === void 0 ? void 0 : metadata.twitterUser
  }, {
    name: "twitter:title",
    content: metadata === null || metadata === void 0 ? void 0 : metadata.title
  }, {
    name: "twitter:url",
    content: metadata === null || metadata === void 0 ? void 0 : metadata.pageUrl
  }, {
    name: "twitter:description",
    content: metadata.description
  }, {
    name: "twitter:image",
    content: (_d = metadata === null || metadata === void 0 ? void 0 : metadata.image) === null || _d === void 0 ? void 0 : _d.url
  }, {
    name: "twitter:image:alt",
    content: (_e = metadata === null || metadata === void 0 ? void 0 : metadata.image) === null || _e === void 0 ? void 0 : _e.description
  }, {
    name: "robots",
    content: metadata === null || metadata === void 0 ? void 0 : metadata.robots
  }].concat(_toConsumableArray(((_f = metadata === null || metadata === void 0 ? void 0 : metadata.googleSiteVerifications) === null || _f === void 0 ? void 0 : _f.map(function (content) {
    return {
      name: "google-site-verification",
      content: content
    };
  })) || []));
};

exports.metaTags = metaTags;